import { User } from "views/settings-users/types";

export enum NotificationKind {
  Mention = "mention"
}

export interface Notification {
  created_at: string;
  id?: string;
  type: NotificationKind;
  user?: User;
  label?: string;
  author: User | string;
  read_at: string | null;
  url: string;
  rich_text?: {
    document_html: string;
    document_text: string;
  };
  metadata: {
    application_id?: string | null;
  };
}

export interface NotificationGroup {
  name: string;
  items: Notification[];
}
